import { render, staticRenderFns } from "./MaterialItemsDrawer.vue?vue&type=template&id=36c129a2"
import script from "./MaterialItemsDrawer.vue?vue&type=script&lang=js"
export * from "./MaterialItemsDrawer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports